import * as React from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc';
import { Box } from "@mui/material";
import { energyProjectTypes, forecastDetachedHouseProjectTypes, forecastProcessingPath, fundingList, statusList, transmissionProjectTypes } from "../TableData";
import { getProjectTypeSelectOptions } from "./utils";

dayjs.extend(utc);



export function pipelineEditorColumn(AllLists: any, getCommonEditTextFieldProps): any[] {
    const customParseFormat = require('dayjs/plugin/customParseFormat')
    dayjs.extend(customParseFormat)
  const minConstructionDate = dayjs('2015', 'YYYY')
  const maxConstructionDate = dayjs('2040', 'YYYY')
    return [
        {
            accessorKey: "Errors",
            header: "Errors",
            size: 200,
            filterFn: "contains",
            Cell: ({ cell }) => {
                const cellValue = cell.getValue();
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%", backgroundColor: cellValue ? "orange" : "" }}>
                    {
                        // @ts-ignore
                        cellValue
                    }
                </Box>;
            },
        },
        {
            accessorKey: "SourceID",
            header: "Original project ID",
            size: 200,
            filterFn: "contains"
        },
        {
            accessorKey: "ProjectName",
            header: "Project name",
            size: 200,
            filterFn: "contains",
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            accessorKey: "State",
            header: "State",
            size: 100,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetState.map((state) => ({
                value: state.State,
                text: state.State
            })) ?? []
        },
        {
            accessorKey: "Source",
            header: "Source",
            size: 150,
            filterVariant: "multi-select",
            editVariant: "select",
            enableEditing: false,
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetSourceList.map((type) => ({
                value: type.Source,
                text: type.Source
            })) ?? []
        },
        {
            id: "Investment",
            accessorFn: (row) => Number(row.Investment),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "Investment ($million)",
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString()
                    }
                </Box>;
            },
            size: 200,
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            accessorKey: "RawProjectType",
            header: "Project type",
            size: 200,
            filterVariant: "multi-select",
            editVariant: "select",
            // @ts-ignore
            editSelectOptions: getProjectTypeSelectOptions(AllLists),
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            accessorKey: "ProjectStage",
            header: "Project latest status",
            size: 250,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: statusList
        },
        {
            id: "StartDateConstruction",
            accessorFn: (row) => row.StartDateConstruction ? dayjs.utc(row.StartDateConstruction, "DD/MM/YYYY") : "",
            header: "Construction start date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                    }
                </Box>;
            }, //render Date as a string
            Filter: ({ column, rangeFilterIndex }) => (
                <DatePicker
                    onChange={(newValue) => {
                        column.setFilterValue((oldValues) => {
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? ["", ""];
                            newValues[rangeFilterIndex.toString()] = newValue;

                            return newValues;
                        });
                    }}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",
                        },
                    }}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                    value={column.getFilterValue()?.[rangeFilterIndex] || null} // Index into the filter value
                />
            ),
            Edit: ({ cell, row }) => (
                <DatePicker
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",

                        },
                    }}
                    onChange={(startDateValue) => {
                        // @ts-ignore
                        row._valuesCache.StartDateConstruction = startDateValue;
                    }
                    }
                    format="DD/MM/YYYY"
                    value={dayjs(cell.getValue())}
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                />
            ),
        },
        {
            id: "EndDateConstruction",
            accessorFn: (row) => row.EndDateConstruction ? dayjs.utc(row.EndDateConstruction, "DD/MM/YYYY") : "",
            header: "Construction end date",
            size: 300,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            // @ts-ignore
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                    }
                </Box>;
            }, //render Date as a string
            //Custom Date Picker Filter from @mui/x-date-pickers
            Filter: ({ column, rangeFilterIndex }) => (
                <DatePicker
                    onChange={(newValue) => {
                        column.setFilterValue((oldValues) => {
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? ["", ""];
                            newValues[rangeFilterIndex] = newValue;

                            return newValues;
                        });
                    }}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",
                        },
                    }}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                    value={column.getFilterValue()?.[rangeFilterIndex] || null} // Index into the filter value
                />
            ),
            Edit: ({ cell, row }) => (
                <DatePicker
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",
                        },
                    }}
                    onChange={(endDateValue) => {
                        // @ts-ignore
                        row._valuesCache.EndDateConstruction = endDateValue;
                    }
                    }
                    value={dayjs(cell.getValue())}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                />
            ),
        },
        {
            accessorKey: "FundingMode",
            header: "Funding mode",
            size: 150,
            filterVariant: "multi-select",
            editVariant: "select",
            editSelectOptions: fundingList,
            enableEditing: (row) => forecastProcessingPath.includes(row.getValue("ProcessingPath")) ? false : true,
        },
        {
            id: "LocationID",
            accessorFn: (row) => row.LocationID ?? "",
            header: "Location",
            size: 300,
            filterVariant: "multi-select",
            editVariant: "select",
            Cell: ({ cell }) => {
                return (
                    // @ts-ignore
                    // if location not found, set to state unknown
                    AllLists?.executeGetLocationList.find(item => item.LocationID == cell.getValue())?.LocationName ?? `${cell.row.getValue("State")} - Unknown`
                )

            },
            filterSelectOptions: AllLists?.executeGetLocationList.map((location) => ({
                value: location.LocationID,
                text: location.LocationName
            })) ?? [],
            // @ts-ignore
            editSelectOptions: AllLists?.executeGetLocationList.map((location) => ({
                value: location.LocationID,
                text: location.LocationName
            })) ?? []
        },
        {
            id: "MW",
            accessorFn: (row) => Number(row.MW),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "MW",
            enableEditing: (row) => energyProjectTypes.includes(row.getValue("RawProjectType")) ? true : false,
            size: 250,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString()
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            id: "km",
            accessorFn: (row) => Number(row.km),
            header: "KM",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 250,
            enableEditing: (row) => [transmissionProjectTypes[1], transmissionProjectTypes[2]].includes(row.getValue("RawProjectType")) ? true : false,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString()
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            id: "M2",
            accessorFn: (row) => Number(row.M2),
            filterFn: "betweenInclusive",
            filterVariant: "range",
            header: "M2",
            enableEditing: (row) => forecastDetachedHouseProjectTypes.includes(row.getValue("RawProjectType")) ? true : false,
            size: 250,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString()
                    }
                </Box>;
            },
            muiTableBodyCellEditTextFieldProps: ({ cell }) => ({
                ...getCommonEditTextFieldProps(cell)
            }),
        },
        {
            id: "PeriodStartYear",
            accessorFn: (row) => row.PeriodStartYear ? dayjs.utc(row.PeriodStartYear, "DD/MM/YYYY") : "",
            header: "Period Start Year",
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                    }
                </Box>;
            }, //render Date as a string
            Filter: ({ column, rangeFilterIndex }) => (
                <DatePicker
                    timezone={"UTC"}
                    onChange={(newValue) => {
                        column.setFilterValue((oldValues) => {
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? ["", ""];
                            newValues[rangeFilterIndex.toString()] = newValue;

                            return newValues;
                        });
                    }}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",
                        },
                    }}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                    value={column.getFilterValue()?.[rangeFilterIndex] || null} // Index into the filter value
                />
            ),
            Edit: ({ cell, row }) => (
                <DatePicker
                    timezone={"UTC"}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",

                        },
                    }}
                    onChange={(startDateValue) => {
                        // @ts-ignore
                        row._valuesCache.PeriodStartYear = startDateValue;
                    }
                    }
                    value={dayjs(cell.getValue())}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                />
            ),
        },
        {
            id: "PeriodEndYear",
            accessorFn: (row) => row.PeriodEndYear ? dayjs.utc(row.PeriodEndYear, "DD/MM/YYYY") : "",
            header: "Period End Year",
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue() ? cell.getValue().format('DD/MM/YYYY') : ""
                    }
                </Box>;
            }, //render Date as a string
            size: 300,
            enableEditing: false,
            filterVariant: "range",
            filterFn: "betweenInclusive",
            sortingFn: "datetime",
            Filter: ({ column, rangeFilterIndex }) => (
                <DatePicker
                    timezone={"UTC"}
                    onChange={(newValue) => {
                        column.setFilterValue((oldValues) => {
                            // Update the correct index of the filter value
                            const newValues = oldValues ?? ["", ""];
                            newValues[rangeFilterIndex.toString()] = newValue;

                            return newValues;
                        });
                    }}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",
                        },
                    }}
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                    value={column.getFilterValue()?.[rangeFilterIndex] || null} // Index into the filter value
                />
            ),
            Edit: ({ cell, row }) => (
                <DatePicker
                    timezone={"UTC"}
                    slotProps={{
                        textField: {
                            sx: { minWidth: "120px" },
                            variant: "standard",

                        },
                    }}
                    onChange={(startDateValue) => {
                        // @ts-ignore
                        row._valuesCache.PeriodEndYear = startDateValue;
                    }
                    }
                    format="DD/MM/YYYY"
                    minDate={minConstructionDate}
                    maxDate={maxConstructionDate}
                    value={dayjs(cell.getValue())}
                />
            ),

        },
        {
            id: "ProcessingPath",
            accessorFn: (row) => Number(row.ProcessingPath),
            header: "Processing Path",
            filterVariant: "range",
            filterFn: "betweenInclusive",
            size: 250,
            enableEditing: false,
            Cell: ({ cell }) => {
                return <Box sx={{ display: "flex", justifyContent: "flex-end", width: "100%" }}>
                    {
                        // @ts-ignore
                        cell.getValue<number>().toLocaleString()
                    }
                </Box>;
            }
        },
    ];
}
